import { CommonSuccess, GenericFailure } from '@playq/services-shared';
import { InventoryPackageBrief } from '@playq/octopus2-economy';

import { useEitherMutation, UseMutationOptionsExtended } from '/api/service-hooks';

import { appsPackagesService, removePackageMutationKey } from './constants';

export const useAppsPackageDelete = (
  options?: UseMutationOptionsExtended<CommonSuccess, GenericFailure | Error, InventoryPackageBrief['content']['id']>
) =>
  useEitherMutation((id) => appsPackagesService.delete(id), {
    mutationKey: removePackageMutationKey,
    ...options,
  });
